<template src="./index.html">
</template>
<script>
	export default {
		name: '',
		components: {},
		props: {
			showdownload: {
				type: Boolean,
				default: false
			},
			filets: {
				type: String,
				default: '通过一个.xls、.xlsx文件你最多可以导入5000条记录'
			},
			filets2: {
				type: String,
				default: ''
			},
			alowfiletype: {
				type: String,
				default: ''
			},

			fileParams: {
				type: Object,
				default: function() {
					return {
						filelist: [],
						filestate:""
						// upfilename:"",
						// upfile:"",
						// filestate:"",
						// filetype:"",
						// filesize:""
					}
				}
			}
		},
		data: function() {
			return {};
		},
		mounted() {
			let dropArea = document.getElementById('drop-area')
			dropArea.addEventListener('drop', this.dropEvent, false)
			dropArea.addEventListener('dragleave', (e) => {
				e.stopPropagation()
				e.preventDefault()
				this.dropActive = false
			})
			dropArea.addEventListener('dragenter', (e) => {
				e.stopPropagation()
				e.preventDefault()
				this.dropActive = true
			})
			dropArea.addEventListener('dragover', (e) => {
				e.stopPropagation()
				e.preventDefault()
				this.dropActive = true
			})
		},
		methods: {
			fordownloadmb() {
				this.$emit("fordownloadmb", true)
			},
			forrefresh() {
				this.fileParams.filelist = []
				this.fileParams.filestate = ""
			},
			dropEvent(e) {
				this.dropActive = false
				e.stopPropagation()
				e.preventDefault()
				this.uploadFile(e.dataTransfer.files)
			},
			uploadFile(files) { // 渲染上传文件
				let arr = files
				for (let i=0;i<arr.length;i++) {
					let file=arr[i]
				if ((file.size / 1024 / 1024) > 100) {
					this.$message.error('文件不能超过100M')
					return false
				}
				let params = {
					upfilename: "",
					upfile: "",
					filestate: this.fileParams.filestate,
					filetype: "",
					filesize: ""
				}
				params.upfilename = file.name
				params.filetype = file.name.split(".")[1]
				if (this.$notemptyandnull(this.alowfiletype) && (!this.alowfiletype.split(",").includes(params
					.filetype))) {
					this.$message.error('存在无法上传的文件类型')
					break
				}
				params.filesize = (file.size / 1024).toFixed(2)
				params.upfile = file
				this.fileParams.filelist.push(params)
				this.$emit("getuploadparams", this.fileParams)
				}
			},
			fordelete(index){
				this.fileParams.filelist.splice(index,1)
				this.$emit("getuploadparams", this.fileParams)
			},
			uploadFileclick($event) {
				let arr=$event.target.files
			for (let i=0;i<arr.length;i++) {
				let file=arr[i]
				if ((file.size / 1024 / 1024) > 100) {
					this.$message.error('单个文件不能超过100M')
					return false
				}
				let params = {
					upfilename: "",
					upfile: "",
					filestate: this.fileParams.filestate,
					filetype: "",
					filesize: ""
				}
				params.upfilename = file.name
				params.filetype = file.name.split(".")[1]
				if (this.$notemptyandnull(this.alowfiletype) && (!this.alowfiletype.split(",").includes(params
						.filetype))) {
					this.$message.error('存在无法上传的文件类型')
					break
				}
				params.filesize = (file.size / 1024).toFixed(2)
				params.upfile = file
				this.fileParams.filelist.push(params)
				this.$emit("getuploadparams", this.fileParams)
			}
			},
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
